export default "__VITE_ASSET___yChIJmP__"